// extracted by mini-css-extract-plugin
module.exports = {"entity":"Preview_entity__3q0Wo","active":"Preview_active__1Vgcj"};